(function () {
  if (window.torrasDeferredProductMedia) return;
  window.torrasDeferredProductMedia = hydrate;

  function upgradePoster(video) {
    if (!video.dataset.pdpPoster || video.dataset.pdpPosterPending === 'true') return;
    video.dataset.pdpPosterPending = 'true';
    var url = video.dataset.pdpPoster;
    var poster = new Image();
    poster.fetchPriority = 'high';
    poster.onload = function () {
      var ready = poster.decode ? poster.decode().catch(function () {}) : Promise.resolve();
      ready.then(function () {
        if (video.isConnected) video.poster = url;
        delete video.dataset.pdpPoster;
        delete video.dataset.pdpPosterPending;
      });
    };
    poster.onerror = function () { delete video.dataset.pdpPosterPending; };
    poster.src = url;
  }

  function hydrate(video) {
    upgradePoster(video);
    if (video.dataset.pdpMediaReady === 'true') return;
    video.dataset.pdpMediaReady = 'true';
    [video].concat(Array.from(video.querySelectorAll('[data-pdp-src]'))).forEach(function (node) {
      if (node.dataset.pdpSrc) {
        node.setAttribute('src', node.dataset.pdpSrc);
        delete node.dataset.pdpSrc;
      }
    });
    video.load();
    if (video.autoplay) video.play().catch(function () {});
  }

  function hydratePicture(picture) {
    if (picture.dataset.pdpImageReady === 'true') return;
    picture.dataset.pdpImageReady = 'true';
    picture.querySelectorAll('[data-pdp-image-srcset]').forEach(function (node) {
      node.setAttribute('srcset', node.dataset.pdpImageSrcset);
      delete node.dataset.pdpImageSrcset;
    });
    var image = picture.querySelector('img[data-pdp-image-src]');
    if (image) {
      image.src = image.dataset.pdpImageSrc;
      delete image.dataset.pdpImageSrc;
    }
  }

  function hydrateMedia(node) {
    if (node.tagName === 'PICTURE') hydratePicture(node);
    else hydrate(node);
  }

  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var bounds = entry.target.getBoundingClientRect();
      if (!entry.isIntersecting || !bounds.width) return;
      // Streaming markup can move after an observer entry was computed.
      if (bounds.top >= window.innerHeight + 800 || bounds.bottom <= -800 || bounds.left >= window.innerWidth || bounds.right <= 0) return;
      hydrateMedia(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '800px 0px', threshold: 0 }) : null;

  var registered = new WeakSet();
  function boot(scope) {
    scope.querySelectorAll('video[data-pdp-deferred-media], picture[data-pdp-deferred-picture]').forEach(function (video) {
      // The marker follows </video>, so every <source> is available before hydration.
      var marker = video.nextElementSibling;
      var markerName = video.tagName === 'PICTURE' ? 'data-pdp-picture-complete' : 'data-pdp-video-complete';
      if (!marker || !marker.hasAttribute(markerName) || registered.has(video)) return;
      registered.add(video);
      if (observer) observer.observe(video);
      else hydrateMedia(video);
    });
  }
  if (document.readyState === 'loading') {
    var markupObserver = new MutationObserver(function () { boot(document); });
    markupObserver.observe(document.documentElement, { childList: true, subtree: true });
    boot(document);
    document.addEventListener('DOMContentLoaded', function () {
      markupObserver.disconnect();
      boot(document);
    }, { once: true });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
